// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1KQeb","main-image":"Header_main-image__2ToE3"};